import React, { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';

const IsLargeScreen: FunctionComponent = ({ children }) => {
  const IsLargeScreen = useMediaQuery({ minWidth: 768 });

  return IsLargeScreen ? <>{children}</> : null;
};

export default IsLargeScreen;
